"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EResidentStatus;
(function (EResidentStatus) {
    EResidentStatus["ACTIVE"] = "ACTIVE";
    EResidentStatus["INACTIVE"] = "INACTIVE";
    EResidentStatus["WAITING"] = "WAITING";
})(EResidentStatus = exports.EResidentStatus || (exports.EResidentStatus = {}));
var EResidentPaymentMethodAccountType;
(function (EResidentPaymentMethodAccountType) {
    EResidentPaymentMethodAccountType["SAVINGS"] = "Savings";
    EResidentPaymentMethodAccountType["CHECKING"] = "Checking";
})(EResidentPaymentMethodAccountType = exports.EResidentPaymentMethodAccountType || (exports.EResidentPaymentMethodAccountType = {}));
var EResidentActivityStatus;
(function (EResidentActivityStatus) {
    EResidentActivityStatus["PENDING"] = "PENDING";
    EResidentActivityStatus["SUCCESS"] = "SUCCESS";
    EResidentActivityStatus["ERROR"] = "ERROR";
})(EResidentActivityStatus = exports.EResidentActivityStatus || (exports.EResidentActivityStatus = {}));
var ERecipientType;
(function (ERecipientType) {
    ERecipientType["MAIL"] = "MAIL";
    ERecipientType["EMAIL"] = "EMAIL";
    ERecipientType["ROOM"] = "ROOM";
})(ERecipientType = exports.ERecipientType || (exports.ERecipientType = {}));
exports.SELF_RELATIONSHIP = 'Self';
